import { tipalti } from '@round/api';
import { useSelect, UseSingleValueSelectParams } from 'Hooks/useSelect';
export type PayeeOption = tipalti.Payee & {
    value: number;
    label: string;
};

const mapToOption = (payee: tipalti.Payee): PayeeOption => ({
    value: payee.id,
    label: payee.company_name || `${payee.first_name} ${payee.last_name}` || '-',
    ...payee,
});

export const fetchOptions = async (params: tipalti.GetPayeesParams, requestInit?: RequestInit) => {
    const response = await tipalti.getPayees(params, requestInit);

    if (response.status !== 200) {
        throw new Error('Could not fetch payees');
    }

    return {
        ...response.data,
        results: response.data.results.map(mapToOption),
    };
};

type Params = Omit<UseSingleValueSelectParams<PayeeOption>, 'isMulti' | 'fetchOptions'> & {
    fetchOptions?: typeof fetchOptions;
};

export default function usePayeeSelect(params: Params) {
    return useSelect({
        ...params,
        isMulti: false,
        fetchOptions: params.fetchOptions || fetchOptions,
    });
}
